module.exports = __webpack_public_path__ + "static/img/yz@2x.fa68549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/yz@2x.png
// module id = Dfe+
// module chunks = 1